import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id DDCE3E75-1E43-45A9-8D94-E24CFD8284B0
 * name toy-brick
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick.svg
 * tags
 */
export const ToyBrickIcon = createSvgIcon(<><path d="M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H21V6Z" /></>, 'ToyBrickIcon');
export default ToyBrickIcon